/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainPaymentMethod } from '../../entities/domain/PaymentMethod'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainPaymentMethodSchema = z.enum(['cash', 'card']) as unknown as ToZod<DomainPaymentMethod>